export const AUTOCOMPLETE_CLASSES = {
  base: 'px-3 py-[1.1rem] block w-full border border-neutral-700 rounded-lg sm:text-sm focus:ring-0 placeholder:text-neutral-700 focus:outline-primary-80 h-12',
  disabled: 'opacity-50 cursor-not-allowed',
} as const;

export const AUTOCOMPLETE_LABEL_CLASSES =
  'absolute text-xs -top-2 left-3 z-10 bg-white px-1 rounded-md transition duration-300 font-medium text-neutral-700' as const;
